/**
 * Global theme behaviors: sticky header shadow, mobile nav drawer,
 * and a subtle scroll-reveal for key content blocks.
 */
(function () {
  var header = document.getElementById('SiteHeader');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var menuToggle = document.getElementById('MenuToggle');
  var mobileNav = document.getElementById('MobileNav');
  if (menuToggle && mobileNav) {
    var openNav = function () {
      mobileNav.classList.add('is-open');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('venture-lock-scroll');
    };
    var closeNav = function () {
      mobileNav.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('venture-lock-scroll');
    };
    menuToggle.addEventListener('click', openNav);
    mobileNav.querySelectorAll('[data-mobile-nav-close]').forEach(function (el) {
      el.addEventListener('click', closeNav);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) closeNav();
    });
  }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealTargets = document.querySelectorAll(
    '.section-head, .pillar, .bento-card, .how-to__step, .testimonial, .spotlight-item, .cod-banner, .final-cta__box, .brand-story__intro, .compare-slider, .reveal-left, .reveal-right'
  );
  // Stagger siblings within the same grid/row for a cascading reveal.
  var groups = {};
  revealTargets.forEach(function (el) {
    var parent = el.parentElement;
    var key = parent ? Array.prototype.indexOf.call(document.querySelectorAll('.section'), parent.closest('.section')) + '-' + parent.className : 'x';
    groups[key] = groups[key] || 0;
    el.style.transitionDelay = Math.min(groups[key] * 80, 480) + 'ms';
    groups[key] += 1;
  });
  if (reduced || !('IntersectionObserver' in window)) {
    revealTargets.forEach(function (el) { el.classList.add('reveal', 'is-visible'); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('reveal'); });
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    revealTargets.forEach(function (el) { observer.observe(el); });
  }

  // Pseudo-3D tilt + specular gloss + grounding shadow on product photos, desktop pointer only.
  function enable3DTilt(el) {
    if (!el) return;
    var raf = null;
    el.addEventListener('mousemove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        var rect = el.getBoundingClientRect();
        var relX = (e.clientX - rect.left) / rect.width - 0.5;
        var relY = (e.clientY - rect.top) / rect.height - 0.5;
        el.style.setProperty('--tilt-y', (relX * 8).toFixed(2) + 'deg');
        el.style.setProperty('--tilt-x', (relY * -8).toFixed(2) + 'deg');
        el.style.setProperty('--gloss-x', (50 + relX * 60).toFixed(1) + '%');
        el.style.setProperty('--gloss-y', (50 + relY * 60).toFixed(1) + '%');
        el.style.setProperty('--shadow-x', (relX * -18).toFixed(1) + 'px');
        el.style.setProperty('--shadow-y', (18 - relY * 10).toFixed(1) + 'px');
        raf = null;
      });
    });
    el.addEventListener('mouseleave', function () {
      ['--tilt-x', '--tilt-y', '--gloss-x', '--gloss-y', '--shadow-x', '--shadow-y'].forEach(function (p) {
        el.style.removeProperty(p);
      });
    });
  }
  if (!reduced && window.matchMedia('(pointer: fine)').matches) {
    enable3DTilt(document.querySelector('.hero__media-frame'));
    enable3DTilt(document.querySelector('.product-gallery__main'));
  }
})();
